import type { IOffice } from './career-main-offices.types'

export const officesData: IOffice[] = [
  {
    id: 'warszawa',
    city: 'Warszawa',
    address: 'Plac Europejski 2',
    postalCode: '00-844 Warszawa',
    link: 'https://maps.app.goo.gl/ggEJfzfvbGCPKiJfA',
    coords: { top: '44%', left: '68%' },
  },
  {
    id: 'krakow',
    city: 'Kraków',
    address: 'Mogilska 65',
    postalCode: '31-545 Kraków',
    link: 'https://maps.app.goo.gl/5Z5gdEY3RhMxG2mh7',
    coords: { top: '75%', left: '57%' },
  },
  {
    id: 'wroclaw',
    city: 'Wrocław',
    address: 'Powstańców Śląskich 28/30',
    postalCode: '53-333 Wrocław',
    link: 'https://maps.app.goo.gl/2BguN9PrX7x4CpgK6',
    coords: { top: '60%', left: '28%' },
  },
  {
    id: 'gdansk',
    city: 'Gdańsk',
    address: 'aleja Grunwaldzka 163',
    postalCode: '80-266 Gdańsk',
    link: 'https://maps.app.goo.gl/wWEKgQgwjQzgh5et5',
    coords: { top: '19.5%', left: '42.5%' },
  },
  {
    id: 'poznan',
    city: 'Poznań',
    address: 'Piątkowska 165',
    postalCode: '60-650 Poznań',
    link: 'https://maps.app.goo.gl/4hf821jwvJYyZbCJ9',
    coords: { top: '45%', left: '26.5%' },
  },
  {
    id: 'rzeszow',
    city: 'Rzeszów',
    address: 'Aleja Armii Krajowej 21',
    postalCode: '35-307 Rzeszów',
    link: 'https://maps.app.goo.gl/rR1p5rjWJQJ6FiCU6',
    coords: { top: '73%', left: '76%' },
  },
  {
    id: 'torun',
    city: 'Toruń',
    address: 'Grudziądzka 46/48',
    postalCode: '87-100 Toruń',
    link: 'https://maps.app.goo.gl/mddcwMb5mqYRqScEA',
    coords: { top: '40%', left: '46%' },
  },
]
